"use strict";

var LiveJs = function () {
  var LiveJs = {};

  /**
   * Initialize event handlers
   */
  var init = function init() {
    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-onclick]')) {
        return;
      }
      e.preventDefault ? e.preventDefault() : e.returnValue = false;
      LiveJs.onClick(e.target.closest('[data-onclick]'));
    });

    // Listen on the page load
    if (typeof Turbolinks != 'undefined' && Turbolinks.supported) {
      document.addEventListener('turbolinks:load', onPageLoad);
    } else {
      document.addEventListener('DOMContentLoaded', onPageLoad);
    }
  };
  var onPageLoad = function onPageLoad() {
    var postData = new FormData(),
      postDataHasData = false,
      parts,
      handler,
      data,
      _tmp,
      key;
    document.querySelectorAll('[data-onload]').forEach(function (el) {
      var _parts$;
      parts = el.getAttribute('data-onload').split('||');
      handler = parts[0];
      data = (_parts$ = parts[1]) !== null && _parts$ !== void 0 ? _parts$ : '';
      if (handler.startsWith('js:')) {
        // JS handler
        executeFunctionByName(handler.split(':')[1], window, data, el);

        // var _tmp = handler.split(':')[1].split('.'); // Object name + method name to execute
        // window[_tmp[0]][_tmp[1] ?? 'handle'](data, $(this));
      } else {
        // backend handler
        // Send only backend part and transform "." to "::"
        postDataHasData = true;
        postData.append(handler.split('->js:')[0].replace('.', '::'), data);
      }
    });
    if (postDataHasData) {
      var _document$body$getAtt;
      FlixUtils.request((_document$body$getAtt = document.body.getAttribute('data-live-url')) !== null && _document$body$getAtt !== void 0 ? _document$body$getAtt : '/_livejs', {
        method: 'POST',
        data: postData
      }).then(function (response) {
        document.querySelectorAll('[data-onload]').forEach(function (el) {
          handler = el.getAttribute('data-onload').split('||')[0];
          if (handler.startsWith('js:')) {
            // JS handler already been executed, skip to the next element
            return;
          }
          parts = handler.split('->js:');
          key = parts[0].replace('.', '::');
          if (parts[1]) {
            executeFunctionByName(parts[1], window, response[key], el);
            // _tmp = parts[1].split('.');
            // window[_tmp[0]][_tmp[1] ?? 'handle'](response[key], $(this));
          } else if (response[key] !== null) {
            el.outerHTML = response[key];
          }
        });
      });
    }
  };

  /**
   * @param {HTMLElement} el 
   */
  LiveJs.onClick = function (el) {
    var _parts$2;
    var postData = new FormData(),
      postDataHasData = false,
      parts,
      handler,
      data,
      _tmp,
      key;
    parts = el.getAttribute('data-onclick').split('||');
    handler = parts[0];
    data = (_parts$2 = parts[1]) !== null && _parts$2 !== void 0 ? _parts$2 : '';
    if (handler.startsWith('js:')) {
      // JS handler
      executeFunctionByName(handler.split(':')[1], window, data, el);

      // var _tmp = handler.split(':')[1].split('.'); // Object name + method name to execute
      // window[_tmp[0]][_tmp[1] ?? 'handle'](data, $(this));
    } else {
      // backend handler
      // Send only backend part and transform "." to "::"
      postDataHasData = true;
      postData.append(handler.split('->js:')[0].replace('.', '::'), data);
    }
    if (postDataHasData) {
      var _document$body$getAtt2;
      FlixUtils.request((_document$body$getAtt2 = document.body.getAttribute('data-live-url')) !== null && _document$body$getAtt2 !== void 0 ? _document$body$getAtt2 : '/_livejs', {
        method: 'POST',
        data: postData
      }).then(function (response) {
        handler = el.getAttribute('data-onclick').split('||')[0];
        if (handler.startsWith('js:')) {
          // JS handler already been executed, skip to the next element
          return;
        }
        parts = handler.split('->js:');
        key = parts[0].replace('.', '::');
        if (parts[1]) {
          executeFunctionByName(parts[1], window, response[key], el);

          // _tmp = parts[1].split('.');
          // window[_tmp[0]][_tmp[1] ?? 'handle'](response[key], el);
        } else {
          el.outerHTML = response[key];
        }
      });
    }
  };

  /**
   * @param {string|element} targetContainer either string selector or jQuery element
   * @param {string} handler for example "Thumbs"
   * @param {mixed} data 
   */
  LiveJs.update = function (targetContainer, handler) {
    var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    if (typeof targetContainer === "string") {
      targetContainer = document.querySelector(targetContainer);
    }
    if (handler.startsWith('js:')) {
      // JS handler
      executeFunctionByName(handler.split(':')[1], window, data !== null && data !== void 0 ? data : '', targetContainer);

      // var _tmp = handler.split(':')[1].split('.');
      // window[_tmp[0]][_tmp[1]](data ?? '', targetContainer);
    } else {
      var _document$body$getAtt3;
      // backend handler
      var postData = new FormData();
      handler = handler.replace('.', '::');
      postData.append(handler, data !== null && data !== void 0 ? data : '');
      FlixUtils.request((_document$body$getAtt3 = document.body.getAttribute('data-live-url')) !== null && _document$body$getAtt3 !== void 0 ? _document$body$getAtt3 : '/_livejs', {
        method: 'POST',
        data: postData
      }).then(function (response) {
        for (var handler in response) {
          if (response[handler] !== null) {
            targetContainer.outerHTML = response[handler];
          }
        }
      });
    }
  };

  /**
   * Helper function to execute function by string variable name
   * 
   * @see https://stackoverflow.com/a/359910
   * @param {string} functionName 
   * @param {object} context usually window
   * @returns {mixed}
   */
  var executeFunctionByName = function executeFunctionByName(functionName, context /*, args */) {
    var args = Array.prototype.slice.call(arguments, 2);
    var namespaces = functionName.split(".");
    var func = namespaces.pop();
    for (var i = 0; i < namespaces.length; i++) {
      context = context[namespaces[i]];
    }
    return context[func].apply(context, args);
  };

  // Initialize stuff
  init();
  return LiveJs;
}();